<template>
  <div
    class="right_body action_body"
    v-loading="isLoading"
    :element-loading-background="loadingBg"
    :element-loading-text="loadingTxt"
  >
    <span class="btn right_sub_btn add_btn" style="margin-right:120px" @click.stop="subCheck">订单释放</span>
    <span class="btn right_sub_btn save_btn" @click.stop="subSave">提交数据</span>
    <span class="btn right_sub_btn del_btn" style="margin-right:240px" @click.stop="goBack">返回</span>
    <div class="active_rumb">
      <span class="txt">生产订单</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <v-head
        :fromData="fromData"
        :noFromData="noFromData"
        :factoryList="this.$store.state.cache.factoryList"
      ></v-head>
    </div>

    <div class="coll list_content">
      <el-tabs v-model="activeName2" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="明细信息" name="first">
          <v-list :fromData="fromData" :noFromData="noFromData" ref="vList"></v-list>
        </el-tab-pane>
        <el-tab-pane label="BOM信息" name="second">
          <v-bom-list :fromData="fromData" :noFromData="noFromData" ref="bomList"></v-bom-list>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { factoryApi } from "api/base.js";
import { productOrder } from "api/business.js";
import { company } from "api/system.js";
import vHead from "./components/orderNewRevise/head.vue";
import VBomList from "./components/orderNewRevise/bomList.vue";
import vList from "./components/orderNewRevise/list.vue";

import { mapState, mapActions } from "vuex";
export default {
  components: {
    vHead,
    VBomList,
    vList
  },
  data() {
    return {
      activeName2: "first",
      textarea: "",
      isLoading: true,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      id: "",
      isChildComponent: false,
      //需要提交的数据
      fromData: {
        orderStates: "0001",
        productOrderNo: "",
        bomDto: {},
        details: []
      },
      //不需要提交的数据
      noFromData: {}
    };
  },
  //设置校验规则
  vuerify: {
    "fromData.voucherDate": [
      "required" //必填项
      /* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
    ]
  },
  computed: {
    errors() {
      return this.$vuerify.$errors;
    }
  },
  watch: {
    fromData: function(val, old) {
      console.log(val, old);
    }
  },
  created() {
    //请求初始数据
    this.getStartData();
    this.registerEventListener();
    // let id = this.$route.params.id;
    // console.log(id)
  },
  methods: {
    /**
     * 注册事件监听
     */
    registerEventListener(){ 
      //点击tab页 
      this.$bus.on('onClickTabPage', this.onClickTabPage);
      //移除tab页
      this.$bus.on('onRemoveTabPage', this.onRemoveTabPage);
    },
    //移除tab页
    onRemoveTabPage(tabName){
       //this.$route.meta.clearCache=true;
       console.log("onRemoveTabPage clearCache="+this.$route.meta.clearCache);
    },  
    //点击tab页 
    onClickTabPage(tabName){
       //this.$route.meta.clearCache=false;
        console.log(" onClickTabPage clearCache="+this.$route.meta.clearCache);
    },
    async handleClick() {
      console.log(this.fromData);
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据加载中...";
      let res = await this.$post(productOrder.bomList, this.fromData);
      // let json = JSON.stringify(this.fromData);
      // console.log(json);
      this.isLoading = false;
      if (res.status) {
        console.log(res);
        this.$store.state.cache.selectedMatterProductOrders =
          res.data.details;
      } else {
        this.$message.error(res.errorMsg + "，请先添加抬头信息和明细信息！");
      }
    },
    ...mapActions("cache", ["clearCache"]),
    //关闭弹窗
    handleClose() {},
    //需要请求的初始数据
    async getStartData() {
      //console.log(this.$store.state.cache.customerList,'==444==');
      //工厂列表
      if (!this.$store.state.cache.factoryList) {
        let factoryList = await this.$post(
          factoryApi.list,
          this.$store.state.getAllPage
        );
        if (factoryList.status) {
          factoryList.data.list.forEach(item => {
            item.value = item.factoryCode + "-" + item.factoryDesc;
          });
          this.$store.state.cache.factoryList = factoryList.data.list;
        } else {
          this.$store.state.cache.factoryList = null;
        }
      }

      //初始化数据
      if (this.$route.params.id) {
        let res = await this.$post(productOrder.find, {
          productOrderNo: this.$route.params.id
        });
        if (res.status) {
          //console.log(res);
          this.fromData = res.data;
          this.fromData.factoryStr = res.data.planFactoryDesc;
          if (res.data.bomDto != null) {
            this.fromData.optionBom = res.data.bomDto.optionBom;
          }
          this.fromData.nachl =
            this.fromData.orderQuantityTotal - this.fromData.deliveryQty;
        } else {
          this.$message.error(res.errorMsg);
        }
      }
      this.isLoading = false;
    },
    goBack() {
      this.$router.go(-1);
    },

    //保存提交数据
    async subSave() {
      let vm = this;
      if (!this.fromData.factoryStr) {
        this.$message.error("请选择工厂");
        return false;
      }
      if (!this.fromData.inventoryId) {
        this.$message.error("请选择库存地点");
        return false;
      }
      if (!this.fromData.orderType) {
        this.$message.error("请选择订单类型");
        return false;
      }
      if (!this.fromData.materialCode) {
        this.$message.error("请选择物料编码");
        return false;
      }
      if (!this.fromData.materialDesc) {
        this.$message.error("请选择物料描述");
        return false;
      }
      if (!this.fromData.optionBom) {
        this.$message.error("请选择BOM版本");
        return false;
      }
      if (!this.fromData.orderStates) {
        this.$message.error("请选择订单状态");
        return false;
      }
      // if (!this.fromData.orderQuantityTotal || !this.fromData.orderConfirmScrap || !this.fromData.deliveryQty || !this.fromData.nachl) {
      //   this.$message.error("请补全明细信息");
      //   return false;
      // }
      this.fromData.details = [];
      // console.log(this.$store.state.cache.selectedMatterProductOrders)
      this.fromData.details = this.$store.state.cache.selectedMatterProductOrders;
      this.fromData.orderStartDate = this.$moment(
        this.fromData.orderStartDate
      ).format("YYYY-MM-DD");
      this.fromData.actualStartDate = this.$moment(
        this.fromData.actualStartDate
      ).format("YYYY-MM-DD");
      this.fromData.basicCompletionDate = this.$moment(
        this.fromData.basicCompletionDate
      ).format("YYYY-MM-DD");
      this.fromData.determineCompleteDate = this.$moment(
        this.fromData.determineCompleteDate
      ).format("YYYY-MM-DD");
      this.fromData.actualReleaseDate = this.$moment(
        this.fromData.actualReleaseDate
      ).format("YYYY-MM-DD");
      console.log(this.fromData, "=====测试数据======");
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";
      let res = await this.$post(productOrder.edit, this.fromData);
      let json = JSON.stringify(this.fromData);
      console.log(json);
      this.isLoading = false;
      if (res.status) {
        console.log(res);
        this.fromData.productOrderNo = res.data.productOrderNo;
        this.$store.state.cache.selectedMatterProductOrder = res.data.details;
        this.$confirm(
          "生产订单 " + res.data.productOrderNo + " 修改成功",
          "提示",
          {
            confirmButtonText: "继续",
            cancelButtonText: "退出",
            type: "success"
          }
        )
          .then(() => {
            // vm.$router.go(-1);
            vm.$keepAliveManager.backSourceRoute(this,{name: "business-production-productorder-search"});
            //清除部分缓存数据
            vm.clearCache(); 
          })
          .catch(() => {
            // vm.$router.push({ name: "home" });
            this.$keepAliveManager.backSourceRoute(this,{name: 'home'});
            this.fromData = {};
            vm.$store.state.cache.selectedMatterProductOrder = [];
            //清除部分缓存数据
            vm.clearCache();
          });
      } else {
        this.$message.error(res.errorMsg);
      }
    },

    //订单释放（修改订单）
    async subCheck() {
      if (!this.fromData.factoryStr) {
        this.$message.error("请选择工厂");
        return false;
      }
      if (!this.fromData.inventoryId) {
        this.$message.error("请选择库存地点");
        return false;
      }
      if (!this.fromData.orderType) {
        this.$message.error("请选择订单类型");
        return false;
      }
      if (!this.fromData.materialCode) {
        this.$message.error("请选择物料编码");
        return false;
      }
      if (!this.fromData.materialDesc) {
        this.$message.error("请选择物料描述");
        return false;
      }
      if (!this.fromData.optionBom) {
        this.$message.error("请选择BOM版本");
        return false;
      }
      // if (!this.fromData.orderQuantityTotal || !this.fromData.orderConfirmScrap || !this.fromData.batchCharacter || !this.fromData.deliveryQty || !this.fromData.nachl) {
      //   this.$message.error("请补全明细信息");
      //   return false;
      // }
      if (!this.fromData.productOrderNo) {
        this.fromData.orderStates = "0002";
        this.$message.success("订单释放成功，请继续提交数据");
        return false;
      } else if (this.fromData.orderStates == "0001") {
        //调用释放方法
        //console.log(this.$store.state.cache.selectedMatterProductOrders[0].componentNum)
        this.fromData.details = [];
        this.fromData.details = this.$store.state.cache.selectedMatterProductOrder;
        //this.fromData.bomDto.bomComponents[0].componentNum = this.$store.state.cache.selectedMatterProductOrders[0].componentNum
        console.log(this.fromData, "=====测试数据======");
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据处理中...";
        let res = await this.$post(productOrder.edit, this.fromData);
        let json = JSON.stringify(this.fromData);
        console.log(json);
        this.isLoading = false;
        if (res.status) {
          console.log(res);
          this.fromData.productOrderNo = res.data.productOrderNo;
          //按钮绿色
          this.fromData.orderStates = "0002";
          this.$message.success(
            "生产订单号" + res.data.productOrderNo + "释放成功，请继续操作"
          );
        } else {
          this.$message.error(res.errorMsg);
        }
      } else {
        //按钮灰色
        this.$message.error("禁止释放订单");
      }
    }
  }
};
</script>

<style lang="stylus" scoped></style>
